import React from "react";

const RecipeList = () => {
    return <div className="shopping-guide">
        <p>🚫 Momentálně nedostupná funkce</p>
    </div>;
};

export default RecipeList;
